// extracted by mini-css-extract-plugin
export default {"readOnlyBadge":"details_readOnlyBadge__e60Jz","badgeInternal":"details_badgeInternal__9avvu","badgeExternal":"details_badgeExternal__KqJ8z"};